import { Link as RouterLink } from 'react-router-dom'
import {
  Button,
  Card,
  CardBody,
  Heading,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react'
import { FileQuestion, Home } from 'lucide-react'

export function NotFoundPage() {
  return (
    <Card maxW="md" mx="auto">
      <CardBody>
        <VStack spacing={4} textAlign="center">
          <Icon as={FileQuestion} boxSize={16} color="stone.400" />
          <Heading size="lg" fontFamily="heading">Page Not Found</Heading>
          <Text color="stone.500">
            The page you're looking for doesn't exist or has been moved.
          </Text>
          <Button as={RouterLink} to="/" leftIcon={<Home size={16} />}>
            Go Home
          </Button>
        </VStack>
      </CardBody>
    </Card>
  )
}
